// @ts-nocheck
import { createRoot } from "react-dom/client";
import "./index.css";
import { Provider } from 'react-redux'
import { persistor, store } from "./redux/store.js";
import { PersistGate } from 'redux-persist/integration/react';
import Loading from "./components/Loading.jsx";
import { SignalRProvider } from "./services/context/SignalRContext.jsx";
import LoadConfig from "./loadconfig.jsx";
import ErrorBoundary from "../ErrorBoundary.jsx";

createRoot(document.getElementById("root")).render(

  <SignalRProvider>
    <Provider store={store}>
      <PersistGate loading={<Loading />} persistor={persistor}>
        <ErrorBoundary>
          <LoadConfig />
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </SignalRProvider>
);